import { MobileWarningModal } from '@/components/Elements/MobileWarningModal/MobileWarningModal';
import { UpgradeModal } from '@/components/UpgradeModal';
import { DateTimePreferencesProvider } from '@/features/date-time-preferences/providers/DateTimePreferencesProvider';
import { ProfileSettingsDialogHost } from '@/features/settings/components/ProfileSettingsDialogHost';
import { ForceLoginState } from '@/providers/ForceLoginState';
import { Outlet, useLocation } from 'react-router';

const shouldShowMobileWarning = (pathname: string) => {
  if (pathname.startsWith('/setup')) return false;
  if (pathname === '/settings/profile') return false;

  return true;
};

export const PrivateApp = () => {
  const { pathname } = useLocation();

  return (
    <ForceLoginState type="loggedInOnly">
      <DateTimePreferencesProvider>
        {shouldShowMobileWarning(pathname) && <MobileWarningModal />}
        <UpgradeModal />
        <ProfileSettingsDialogHost />
        <Outlet />
      </DateTimePreferencesProvider>
    </ForceLoginState>
  );
};
